// extracted by mini-css-extract-plugin
module.exports = {"root":"HardwareCounter_root__CH3Wr","input":"HardwareCounter_input__PkUPS"};